import { keysToCamelCase } from '@wix/wix-vod-shared/common';
export const parseSuccessResponse = ({ data }) => {
    const camelCasedData = keysToCamelCase(data);
    const { createdTs, updatedTs } = camelCasedData;
    const createdTsDate = new Date(Number(createdTs) * 1000);
    const updatedTsDate = new Date(Number(updatedTs) * 1000);
    return Object.assign(Object.assign({}, camelCasedData), { createdTs: createdTsDate, updatedTs: updatedTsDate });
};
//# sourceMappingURL=success-response.js.map